/* Multiline ellipsis */

.sc-line-clamp {
  display: -webkit-box;
  white-space: normal;
  -webkit-box-orient: vertical;

  &-1 {
    @extend .sc-line-clamp;
    -webkit-line-clamp: 1;
  }

  &-2 {
    @extend .sc-line-clamp;
    -webkit-line-clamp: 2;
  }

  &-3 {
    @extend .sc-line-clamp;
    -webkit-line-clamp: 3;
  }
}
